// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2KxvP","balanceDisclaimer":"posDashboard_balanceDisclaimer__2V1lU"};